export default {"src":"/_next/static/media/angle-right.2315d58f.svg","height":12,"width":7,"blurWidth":0,"blurHeight":0};